import { IDatabase, IUserDetails } from "interfaces";

/**
 * Returns "name : type" for the selected database from user details.
 * Used by SidebarNav for the Database menu label.
 */
export function getDatabaseDisplayFromUser(
  user: IUserDetails | null,
  currentDbId: string | null
): string {
  const dbs = user?.databases;
  if (!dbs?.length) return "—";
  const id = currentDbId || dbs[0]?.id;
  const row = dbs.find((x: IDatabase) => x.id === id);
  if (!row) return "—";
  return `${row.name ?? ""} : ${row.type ?? ""}`;
}

/**
 * Parses USER_DETAILS cookie string and returns "name : type" for the current database.
 * Returns "—" for empty, invalid, or missing data. Safe against malformed JSON.
 */
export function getDisplayFromUserDetails(
  userDetailsJson: string | null | undefined,
  databaseId: string | null | undefined
): string {
  if (userDetailsJson == null || typeof userDetailsJson !== "string") return "—";
  const trimmed = userDetailsJson.trim();
  if (!trimmed) return "—";
  try {
    const parsed = JSON.parse(trimmed) as IUserDetails | null;
    if (!parsed?.databases?.length) return "—";
    const currentDbId = databaseId && String(databaseId).trim() ? String(databaseId).trim() : null;
    return getDatabaseDisplayFromUser(parsed, currentDbId);
  } catch {
    return "—";
  }
}
